import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_RAM_ROM = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="RAM and ROM Organization"
      videos={[
        "https://www.youtube.com/embed/MLMTNTzP_CI", // Internal RAM Structure of 8051
        "https://www.youtube.com/embed/j0_RUr_QvTU", // ROM Organization of 8051
      ]}
      takeaways={[
        { text: "How to change register bank using Program Status Word (PSW)." },
        { text: "Understand the default space allocated for the stack in memory." },
        { text: "Direct questions on RAM and ROM organization may appear in exams." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_RAM_ROM;
